import React, { FC } from "react";
import { useIsDesktop } from "src/hooks/viewport/useViewportCategory";
import DesktopModules from "./components/DesktopModules";
import Modules, { ModulesProps } from "./components/ModulesList";
import { useModulesUpdatedWithFavIfHas } from "./utils";

const NavModules: FC<ModulesProps> = ({ moduleIds, ...rest }) => {
  const isDesktop = useIsDesktop();

  const updatedModules = useModulesUpdatedWithFavIfHas(moduleIds);

  if (!isDesktop) return <Modules moduleIds={updatedModules} {...rest} />;

  return <DesktopModules moduleIds={updatedModules} {...rest} />;
};

export default NavModules;
